<template>
  <div class="row">
    <!-- {{roomDetail}} -->
    <!-- {{contactIdArr}} -->
    <!-- {{selectedContact}} -->
    <div class="col-sm-12 col-md-12">
      <!-- <div class="form-group"> -->
      <multiselect
        v-model="selectedContact"
        id="ajax"
        label="name"
        track-by="id"
        :placeholder="''"
        :multiple="true"
        :custom-label="customLabel"
        :options="contactOptions"
        :searchable="true"
        :loading="isLoading"
        :internal-search="false"
        :close-on-select="false"
        :options-limit="300"
        :limit="3"
        :limit-text="limitText"
        :max-height="600"
        :show-no-results="true"
        @search-change="asyncFind"
        :taggable="true"
        @tag="addTag"
        @select="dispatchSelectOption"
        @remove="remove"
      >
        <template slot="tag" slot-scope="{ option, remove }">
          <span class="custom__tag">
            <span>{{ option.name }}</span>
            <span class="custom__remove" @click="remove(option)">❌</span>
          </span>
        </template>
        <template slot="clear" slot-scope="props">
          <div
            class="multiselect__clear"
            v-if="selectedContact.length"
            @mousedown.prevent.stop="clearAll(props.search)"
          ></div>
        </template>
        <span slot="noResult">Oops! No elements found.</span>
      </multiselect>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    Multiselect
  },

  props: {
    getWhatsappNumberFromJid: {
      type: Function
    },
    roomDetail: {
      type: Object,
      default: 0,
      default: function() {
        return {
          id: "",
          room_photo: "",
          room_number: ""
        };
      }
      // required: true
    }
  },
  data() {
    return {
      isSending: false,
      currentConditions: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      contactParam: {
        phone: "",
        auto_create: true, //otomatis dibuat jika data tidak ditemukan
        detail: {
          email: "",
          provider: "whatsapp",
          phone_number: "",
          first_name: "",
          phone_number_group: "",
          is_group: 0
        }
      },
      contactIdArr: []
    };
    //  isactive : true
  },
  watch: {
    roomDetail: {
      handler: function(val, oldVal) {
        // console.log("oldVal", oldVal);
        if (val != oldVal) {
          this.contactIdArr = [];
          this.selectedContact = [];
          if (typeof val.id != "undefined" && val != "") {
            let phoneNumberStr = this.getWhatsappNumberFromJid(val.room_number);
            if (val.is_group == 0) {
              this.getContactIdByPhone(phoneNumberStr);
            } else {
              this.getContactIdByGroup(val.room_number);
            }
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.asyncFind("");
  },
  methods: {
    async remove(tag) {
      if (
        this.contactIdArr == null ||
        this.contactIdArr.length == 0 ||
        this.contactIdArr == ""
      ) {
        this.isLoading = false;
        return false;
      }

      await this.contactIdArr.forEach((row, index) => {
        let paramContactId = row.id;
        this.isLoading = true;
        let param = {
          tag_id: tag.id,
          contact_id: paramContactId
        };
        this.$store
          .dispatch("crm/unassignFromOneTag", param)
          .then(response => {
            this.isLoading = false;
          }) // sesuai kan dengan method di API
          .catch(error => {
            this.isLoading = false;
          });
      });

      // if (this.selectedContact.length == 0) {
      //   this.contactIdArr.forEach((row, index) => {
      //     let idContact = row.id;
      //     if (index == 0) {
      //       this.getTagDetailByContactId(idContact);
      //       // this.isLoading = true;
      //     }
      //   });
      // }
    },

    getTagDetailByContactId(contactId) {
      this.selectedContact = [];
      this.isLoading = true;
      let param = {
        contact_id: contactId,
        room_id: this.roomDetail.id
      };
      this.$store
        .dispatch("crm/getTagDetailByContactId", param)
        .then(response => {
          this.isLoading = false;
          // this.contactOptions = response.data.data;
          if (response.data != null) {
            this.selectedContact = response.data;
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    getContactIdByGroup(numberGroup) {
      this.contactIdArr = [];
      this.isLoading = true;
      let param = {
        number_group: numberGroup,
        auto_create: true,
        detail: {
          email: this.roomDetail.room_number,
          provider: this.roomDetail.provider,
          phone_number: "",
          first_name: this.roomDetail.room_title,
          phone_number_group: this.roomDetail.room_number,
          is_group: 1
        }
      };
      this.$store
        .dispatch("contact/getContactIdByGroup", param)
        .then(response => {
          this.isLoading = false;
          // this.contactOptions = response.data.data;
          this.contactIdArr = response.data;
          if (
            this.contactIdArr == null ||
            this.contactIdArr.length == 0 ||
            this.contactIdArr == ""
          ) {
            this.isLoading = false;

            return false;
          } else {
            this.contactIdArr.forEach((row, index) => {
              let idContact = row.id;
              if (index == 0) {
                this.getTagDetailByContactId(idContact);
                this.isLoading = false;
              }
            });
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    getContactIdByPhone(phoneNumber) {
      this.contactIdArr = [];
      this.isLoading = true;
      this.contactParam.phone = phoneNumber;
      this.contactParam.auto_create = true;
      this.contactParam.detail = {
        email: this.roomDetail.room_number,
        provider: this.roomDetail.provider,
        phone_number: this.getWhatsappNumberFromJid(
          this.roomDetail.room_number
        ),
        first_name: this.roomDetail.room_title,
        phone_number_group: "",
        is_group: 0
      };
      this.$store
        .dispatch("contact/getContactIdByPhone", this.contactParam)
        .then(response => {
          this.isLoading = false;
          // this.contactOptions = response.data.data;
          this.contactIdArr = response.data;
          console.log("this.contactIdArr", this.contactIdArr);
          if (
            this.contactIdArr == null ||
            this.contactIdArr.length == 0 ||
            this.contactIdArr == ""
          ) {
            this.isLoading = false;

            return false;
          } else {
            this.contactIdArr.forEach((row, index) => {
              let idContact = row.id;
              if (index == 0) {
                this.getTagDetailByContactId(idContact);
                this.isLoading = true;
              }
            });
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    dispatchSelectOption(optionSelected) {
      if (
        this.contactIdArr == null ||
        this.contactIdArr.length == 0 ||
        this.contactIdArr == ""
      ) {
        return false;
      }

      this.contactIdArr.forEach((row, index) => {
        let tagIdArr = [];
        // console.log("rowww", row);
        let idTag = optionSelected.id;
        let idContact = row.id;
        tagIdArr.push(idTag.toString());

        let formParam = {
          id: idContact.toString(),
          room_id: this.roomDetail.id,
          tag_id: tagIdArr
        };
        this.$store
          .dispatch("crm/assignContactToTag", formParam)
          .then(response => {
            // var { data } = response;
            this.isSending = false;
          })
          .catch(() => {
            this.isSending = false;
          });
      });

      // console.log(optionSelected);
      //
    },
    async addTag(newTag) {
      console.log("newTag", newTag);
      console.log("selectedCont", this.selectedContact);
      let formParam = {
        id: "",
        name: newTag,
        description: ""
      };
      this.isSending = await true;

      await this.$store
        .dispatch("crm/createTag", formParam)
        .then(response => {
          var { data } = response;
          this.isSending = false;
          this.selectedContact.push(data);
          this.contactOptions.push(data);

          //add tag
          this.contactIdArr.forEach((row, index) => {
            let tagIdArr = [];
            let idTag = data.id;
            let idContact = row.id;
            tagIdArr.push(idTag.toString());

            let formParam = {
              id: idContact.toString(),
              room_id: this.roomDetail.id,
              tag_id: tagIdArr
            };
            this.$store
              .dispatch("crm/assignContactToTag", formParam)
              .then(response => {
                // var { data } = response;
                this.isSending = false;
              })
              .catch(() => {
                this.isSending = false;
              });
          });
        })
        .catch(() => {
          this.isSending = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("crm/listTags", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  mounted() {},
  name: "tagsAssign"
};
</script>


// WEBPACK FOOTER //
// src/views/omni/components/tagsAssign.vue